/**
 * Products module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AmountsEditor from '@src/Products/Pages/Fields/AmountsEditor.vue';
import AttributesEditor from '@src/Products/Pages/Fields/AttributesEditor.vue';
import ConfigurationsEditor from '@src/Products/Pages/Fields/ConfigurationsEditor.vue';
import VariantsEditor from '@src/Products/Pages/Fields/VariantsEditor.vue';
import AdminProductType from '@src/Products/Pages/Fields/AdminProductType.vue';
import GridProductType from '@src/Products/Pages/Fields/GridProductType.vue';

export const setup = (app: App<Element>): void => {
    app.component('AmountsEditor', AmountsEditor);
    app.component('AttributesEditor', AttributesEditor);
    app.component('ConfigurationsEditor', ConfigurationsEditor);
    app.component('VariantsEditor', VariantsEditor);
    app.component('AdminProductType', AdminProductType);
    app.component('GridProductType', GridProductType);
};
